import React, { Component } from 'react';
import { connect } from 'react-redux';
import Xarrow from 'react-xarrows';

import {
  Accordion,
  Image,
  Grid,
  Popup,
  Header,
} from 'semantic-ui-react';
import {
  SELECT_ROUTE,
} from '../actions/types';
import {
  selectRoute,
} from '../actions/interactionActions';

import Booking from '../components/Booking';
import PublicTransportInformation from '../components/PublicTransportInformation';
import dot from '../images/itinerary/start.svg';
import parking from '../images/itinerary/parking.svg';
import pr from '../images/itinerary/pr.svg';
import marker from '../images/itinerary/destination.svg';
import minimize from '../images/itinerary/minimize.svg';
import maximize from '../images/itinerary/maximize.svg';
import info from '../images/itinerary/info.svg';
import parkingCosts from '../images/itinerary/parkingCosts.svg';
import publicTransitCosts from '../images/itinerary/publicTransitCosts.svg';

import PedestrianInformation from './PedestrianInformation';
import ParkingLotPopup from './ParkingLotPopup';
//const colors = require('../data/colors.json');
const infoImage = <Image src={info} height='16px' spaced='left' inline />;


/**
 * Component for displaying the different itineraries the user can choose from in the sidebar
 */
class Itinerary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startId: 'start' + props.index,
      destinationId: 'destination' + props.index,
      parkingId: 'parking' + props.index,
      entryId: 'entry' + props.index,
      exitId: 'exit' + props.index,
    };
  }

  resetLine = () => {
    console.log('restting');
    const destination = this.state.destinationId;

    this.setState({
      destinationId: this.state.startId,
    });

    setTimeout(() => { this.setState({ destinationId: destination, }) }, 100);
  }

  //  activate clicked dropwdown and deactivate the previously active one
  handleDropdownClick = (e, clickedIndex) => {
    const { index } = clickedIndex;
    const { active } = this.props.selectedRoute;
    const newIndex = active === index ? -1 : index;
    this.props.selectRoute(newIndex, SELECT_ROUTE);
  }

  displayIntermediateStops = () => {
    try {
      const sections = this.props.route[this.props.index].sections;
      const transitLength = sections.length - 1;
      let output = [];

      output.push(<PedestrianInformation key={sections[1].id} duration={sections[1].travelSummary.duration / 60} />);
      for (let i = 2; i < transitLength; i++) {

        if (sections[i].type === 'transit') {
          if(i === transitLength - 1 && i === 2) {
            output.push(<PublicTransportInformation key={sections[i].id + 'transit' + i} index={this.props.index} firstStation={true} finalStation={true} section={sections[i]} key={sections[i].id} index={this.props.index} />);
          } else if (i === transitLength - 1) {
            output.push(<PublicTransportInformation key={sections[i].id + 'transit' + i} index={this.props.index} firstStation={false} finalStation={true} section={sections[i]} key={sections[i].id} index={this.props.index} />);
          } else if (i === 2) {
            output.push(<PublicTransportInformation key={sections[i].id + 'transit' + i} index={this.props.index} firstStation={true} finalStation={false} section={sections[i]} key={sections[i].id} index={this.props.index} />);
          } else {
            output.push(<PublicTransportInformation key={sections[i].id + 'transit' + i} index={this.props.index} firstStation={false} finalStation={false} section={sections[i]} key={sections[i].id} index={this.props.index} />);
          }


          if (sections[i].arrival.place.name !== sections[i + 1].departure.place.name) {
            output.push(<PedestrianInformation key={sections[i + 1].id} duration={sections[i + 1].travelSummary.duration / 60} />);
          }
        }
      }

      output.push(<PedestrianInformation key={sections[sections.length - 1]} duration={sections[sections.length - 1].travelSummary.duration / 60} />);
      return output;
    } catch (error) {

    }
  }

  displayParkingPrice = () => {
    let price = this.props.parkingPrices[this.props.index];
    const selected = this.props.selectedRoute === this.props.index;

    if (price === '0 €') {
      price = 'Gratis';
    }

    if (selected) {
      return (
        <Grid.Row>
          <Grid.Column style={{ paddingLeft: 0, paddingRight: 0 }}>
            <Image src={parkingCosts} width='16px' spaced='right' inline />
            {price}
            <Popup
              style={{ background: '#656565', backgroundColor: '#656565', borderColor: '#656565' }}
              position='bottom center'
              inverted
              content={"Angaben ohne Gewähr. Die Parkkosten beziehen sich auf eine Parkdauer von 24 Stunden bzw. auf der jeweiligen Höchstparkdauer."}
              trigger={infoImage}
            />
          </Grid.Column>
        </Grid.Row>
      );
    } else {
      return (
        <Grid.Row>
          <Grid.Column>
            {price}
          </Grid.Column>
        </Grid.Row>
      );
    }
  }
  getParkingLotImage = () => {
    const parkingLotName = this.props.parkingLotNames[this.props.index].toString();

    if (parkingLotName.includes('P+R')) {
      return pr;
    } else {
      return parking;
    }
  }

  render() {
    return (
      <>
        <Accordion.Title
          active={this.props.selectedRoute === this.props.index}
          index={this.props.index}
          onClick={this.handleDropdownClick}
        >
          <Grid verticalAlign='middle'>
            <Grid.Row style={{ marginRight: '1rem', marginLeft: '1rem' }}>
              <Grid.Column width={4} style={{ paddingLeft: '0px', paddingRight: '0px', fontWeight: 'bold', fontSize: '16px', }}>
                {this.props.times[this.props.index]}
              </Grid.Column>
              <Grid.Column width={5} style={{ marginLeft: '3.5rem', marginRight: '4.3rem', fontSize: '14px', color: '#656565' }}>
                <Grid>
                  {this.displayParkingPrice()}
                </Grid>
              </Grid.Column>
              <Grid.Column width={2} style={{ paddingLeft: '0px', paddingRight: '0px', verticalAlign:'right'}}>
                <Image width='24px' src={this.props.selectedRoute === this.props.index ? minimize : maximize} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Title>

        <Accordion.Content active={this.props.selectedRoute === this.props.index}>
          <Grid verticalAlign='middle'>
            <Grid.Row>
              <Grid.Column width={3}>
                <Image id={this.state.startId} width='24px' src={dot} spaced='left' style={{ zIndex: 1 }} />
              </Grid.Column>
              <Grid.Column width={9} textAlign='left'>
                <Header size='medium' content={this.props.selectedStart} />
              </Grid.Column>
              <Grid.Column width={4}>
                <div className='grey'>
                  {this.props.departureTimes[this.props.index]}
                </div>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={3}>
                <Image id={this.state.parkingId} width='24px' src={this.getParkingLotImage()} spaced='left' style={{ zIndex: 1 }} />

              </Grid.Column>
              <Grid.Column width={9} textAlign='left'>
                <Header size='medium' content={this.props.parkingLotNames[this.props.index]} />
              </Grid.Column>
              <Grid.Column width={4}>
                <div className='grey'>
                  {this.props.parkingTimes[this.props.index]}
                </div>
              </Grid.Column>
            </Grid.Row>

            {this.displayIntermediateStops()}
            <Grid.Row>
              <Grid.Column width={3}>
                <Image id={this.state.destinationId} height='26px' src={marker} spaced='left' style={{ zIndex: 1 }} />
              </Grid.Column>
              <Grid.Column width={9} textAlign='left'>
                <Header size='medium' content={this.props.selectedDestination} />
              </Grid.Column>
              <Grid.Column width={4}>
                <div className='grey'>
                  {this.props.arrivalTimes[this.props.index]}
                </div>
              </Grid.Column>
            </Grid.Row>
            
            <Xarrow
              start={this.state.startId}
              end={this.state.parkingId}
              startAnchor='top' endAnchor='top'
              color='#656565'
              headSize={0}
            />
          </Grid>
        </Accordion.Content>
        <ParkingLotPopup
          visible={this.props.selectedRoute === this.props.index}
          name={this.props.parkingLotNames[this.props.index]}
          address={this.props.parkingLotAddresses[this.props.index]}
          index={this.props.index}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  selectedRoute: state.posts.selectedRoute,
  startValue: state.posts.startValue,
  destinationValue: state.posts.destinationValue,
  times: state.posts.times,
  departureTimes: state.posts.departureTimes,
  arrivalTimes: state.posts.arrivalTimes,
  parkingTimes: state.posts.parkingTimes,
  parkingLotNames: state.posts.parkingLotNames,
  selectedStart: state.posts.selectedStart.content,
  selectedDestination: state.posts.selectedDestination.content,
  parkingPrices: state.posts.parkingPrices,
  parkingLotAddresses: state.posts.parkingLotAddresses,
  route: state.posts.route,
});

export default connect(mapStateToProps, { selectRoute })(Itinerary)